import React from "react";
import { Route, Switch, useHistory } from "react-router-dom";

import TranscodeVideoModal from "widgets/modals/TranscodeVideoModal";
import BulkTranscodeModal from "widgets/modals/assets/BulkTranscodeModal";

export default function Modals({ screenPath, returnPath, libraryId }){
	const history = useHistory();
	return (
		<Switch>
			<Route
				exact
				path   = {`/library/:libraryId/assets/modal/transcode/:videoId/`}
				render = {(routeRenderProps) => {
					let { videoId } = routeRenderProps.match.params;
					return (
						<TranscodeVideoModal
							libraryId = {libraryId}
							videoId = {videoId}
							returnPath = {returnPath}
						/>
					);
				}}
			/>

			<Route
				exact
				path   = {`/library/:libraryId/assets/modal/bulk-transcode/`}
				render = {(routeRenderProps) => {
					return (
						<BulkTranscodeModal
							libraryId = {libraryId}
							onClose = {() => { history.push(returnPath); }}
						/>
					);
				}}
			/>
		</Switch>
	);
}

Modals.displayName = "AssetModals";
